import { Router, RouterStateSnapshot } from '@angular/router';
import { Injectable, inject } from '@angular/core';

import { environment } from '@env/environment';
import { setWindowLocation } from '@helpers/url';

@Injectable({
  providedIn: 'root'
})
export class FlowDotComRedirectGuard {
  private router = inject(Router);

  canActivate(state: RouterStateSnapshot): boolean {
    let path: string = state.url;

    if (environment.runtimeEnv !== 'production') {
      return true;
    }

    switch (path) {
      case '/terms-of-use':
        setWindowLocation(environment.TERMS_OF_USE_URL);
        break;
      case '/privacy':
        setWindowLocation(environment.PRIVACY_POLICY_URL);
        break;
      default:
        void this.router.navigate(['/login']);
    }

    return false;
  }
}
